import * as e from "react";
export function usePrevious(r) {
  var t = e.useRef(r);
  return e.useEffect(function () {
    t.current = r;
  }, [r]), t.current;
}